import {
  Descriptions,
  Table,
  Tag,
  Tooltip,
  Typography,
  Input,
  Button,
  Space,
} from "antd";
import React, { useState, useRef } from "react";
import { SearchOutlined } from "@ant-design/icons";

const StockSelection = (props) => {
  //console.log("SelectedIds:", props.selectedIds);
  const [selectedRowKeys, setSelectedRowKeys] = useState(props.selectedIds);
  const [searchText, setSearchText] = useState("");
  const [searchedColumn, setSearchedColumn] = useState("");
  const [selectedStocks, setSelectedStocks] = useState([]);
  const searchInput = useRef(null);

  const { Text } = Typography;

  const onSelectChange = (selectedRowKeys) => {
    setSelectedRowKeys(selectedRowKeys);
    const selectedItems = props.stocks.filter((item) =>
      selectedRowKeys.includes(item.id)
    );
    // console.log("SelectStocks:", selectedItems);
    setSelectedStocks(selectedItems);
    props.onSelectChange(selectedRowKeys);
  };

  const rowSelection = {
    selectedRowKeys,
    onChange: onSelectChange,
  };

  const getColumnSearchProps = (dataIndex) => ({
    filterDropdown: ({
      setSelectedKeys,
      selectedKeys,
      confirm,
      clearFilters,
    }) => (
      <div style={{ padding: 8 }}>
        <Input
          ref={searchInput}
          placeholder={`Search ${dataIndex}`}
          value={selectedKeys[0]}
          onChange={(e) =>
            setSelectedKeys(e.target.value ? [e.target.value] : [])
          }
          onPressEnter={() => handleSearch(selectedKeys, confirm, dataIndex)}
          style={{ width: 188, marginBottom: 8, display: "block" }}
        />
        <Space>
          <Button
            type="primary"
            onClick={() => handleSearch(selectedKeys, confirm, dataIndex)}
            icon={<SearchOutlined />}
            size="small"
            style={{ width: 90 }}
          >
            Search
          </Button>
          <Button
            onClick={() => handleReset(clearFilters)}
            size="small"
            style={{ width: 90 }}
          >
            Reset
          </Button>
          <Button
            type="link"
            size="small"
            onClick={() => {
              confirm({ closeDropdown: false });
              setSearchText(selectedKeys[0]);
              setSearchedColumn(dataIndex);
            }}
          >
            Filter
          </Button>
        </Space>
      </div>
    ),
    filterIcon: (filtered) => (
      <SearchOutlined style={{ color: filtered ? "#1890ff" : undefined }} />
    ),
    onFilter: (value, record) =>
      record[dataIndex]
        ? dataIndex === "runningNo"
          ? record[dataIndex].toString().toLowerCase() === value.toLowerCase()
          : record[dataIndex]
            .toString()
            .toLowerCase()
            .includes(value.toLowerCase())
        : "",
    onFilterDropdownVisibleChange: (visible) => {
      if (visible) {
        setTimeout(
          () =>
            searchInput && searchInput.current && searchInput.current.select(),
          100
        );
      }
    },
    render: (text) => (searchedColumn === dataIndex ? text : text),
  });

  const handleSearch = (selectedKeys, confirm, dataIndex) => {
    confirm();
    setSearchText(selectedKeys[0]);
    setSearchedColumn(dataIndex);
  };

  const handleReset = (clearFilters) => {
    clearFilters();
    setSearchText("");
  };

  const getColumns = () => {
    let columns = [];
    columns.push({
      title: "Material",
      dataIndex: "stockType",
      key: "stockType",
      width: "8%",
      render: (text, record) => {
        return record.stockType.code;
      },
    });
    columns.push({
      title: "Description",
      key: "stockTypeName",
      width: "10%",
      ellipsis: {
        showTitle: false,
      },
      render: (text, record) => {
        return (
          <Tooltip placeholder="topLeft" title={record.stockType.name}>
            {record.stockType.name}
          </Tooltip>
        );
      },
    });
    columns.push({
      title: "Lot",
      dataIndex: "lotNumber",
      key: "lotNumber",
      width: "10%",
      render: (text, record) => {
        return record.lotNumber && record.lotNumber.number;
      },
    });
    columns.push({
      title: "Prod Date",
      dataIndex: "productionDate",
      key: "productionDate",
      width: "8%",
      /* render: (text, record) => {
        return (
          record.stockPreReceiptLine &&
          record.stockPreReceiptLine.stockPreReceipt &&
          moment(record.stockPreReceiptLine.stockPreReceipt.orderDate).format(
            "YYYY-MM-DD"
          )
        );
      }, */
      /* defaultSortOrder: "ascend",
      sorter: (a, b) => moment(a.productionDate).unix() - moment(b.productionDate).unix(), */
    });
    columns.push({
      title: "Recv Date",
      dataIndex: "receivedDate",
      key: "receivedDate",
      width: "8%",
      /* render: (text, record) => {
        return (
          record.stockPreReceiptLine &&
          record.stockPreReceiptLine.stockPreReceipt &&
          moment(record.stockPreReceiptLine.stockPreReceipt.orderDate).format(
            "YYYY-MM-DD"
          )
        );
      }, */
      /* defaultSortOrder: "ascend",
      sorter: (a, b) => moment(a.createdAt).unix() - moment(b.createdAt).unix(), */
    });
    columns.push({
      title: "Supplier",
      dataIndex: "supplier",
      key: "supplier",
      width: "8%",
      ellipsis: {
        showTitle: false,
      },
      render: (text, record) => {
        if (record.stockType.supplier) {
          return (
            <Tooltip placeholder="topLeft" title={record.stockType.supplier.name}>
              {record.stockType.supplier.code}
            </Tooltip>
          );
        }
      },
    });
    columns.push({
      title: "Box Serial",
      dataIndex: "serialNo",
      key: "serialNo",
      width: "13%",
      defaultSortOrder: "descend",
      //sorter: (a, b) => parseInt(a.runningNo) < parseInt(b.runningNo),
      ...getColumnSearchProps("serialNo"),
    });
    columns.push({
      title: "Bin",
      dataIndex: "stockBin",
      key: "stockBin",
      width: "6%",
      render: (text, record) => {
        return record.stockBin.code;
      },
    });
    columns.push({
      title: "Plt No",
      dataIndex: "palletNo",
      key: "palletNo",
      width: "3%",
      ...getColumnSearchProps("palletNo"),
    });
    columns.push({
      title: "Box No",
      dataIndex: "tempNumber",
      key: "tempNumber",
      width: "5%",
      ...getColumnSearchProps("tempNumber"),
    });
    columns.push({
      title: "Cone",
      dataIndex: "quantity",
      key: "quantity",
      align: "right",
      width: "5%",
      /* render: (text, record) => {
        return text && Number(text).toFixed(2);
      }, */
    });
    columns.push({
      title: "Net Weight",
      dataIndex: "netWeight",
      key: "netWeight",
      align: "right",
      width: "8%",
      render: (text, record) => {
        return text && Number(text).toFixed(2);
      },
      ...getColumnSearchProps("netWeight"),
    });
    columns.push({
      title: "Status",
      dataIndex: "mode",
      key: "mode",
      width: "8%",
      render: (text) => {
        let color = "";
        if (text === "AVAILABLE") {
          color = "#87d068";
        }
        if (text === "REQUESTED") {
          color = "#2db7f5";
        }
        if (text === "ISSUED") {
          color = "#108ee9";
        }
        if (text === "DELIVERED") {
          color = "#f50";
        }
        return <Tag color={color}>{text}</Tag>;
      },
    });
    /* columns.push({
      title: "Gross Weight",
      dataIndex: "grossWeight",
      key: "grossWeight",
      align: "right",
      width: "6%",
      render: (text, record) => {
        return text && Number(text).toFixed(2);
      },
      ...getColumnSearchProps("grossWeight"),
    }); */
    /* columns.push({
      title: "UOM",
      dataIndex: "measurementType",
      key: "measurementType",
      width: "3%",
      render: (text, record) => {
        return record.measurementType && record.measurementType.name;
      },
    }); */
    /* columns.push({
      title: "Due Days",
      key: "dueDays",
      width: "5%",
      render: (text, record) => {
        return (
          record.stockPreReceiptLine &&
          record.stockPreReceiptLine.stockPreReceipt &&
          moment(moment()).diff(
            record.stockPreReceiptLine.stockPreReceipt.orderDate,
            "days"
          )
        );
      },
    }); */

    return columns;
  };

  const getRowColor = (record) => {
    let rowColor = "";
    if (record && record.packingStatus === "RETURN") {
      rowColor = "st-row-return";
    }

    return rowColor;
  }

  return (
    <div>
      <Table
        bordered
        rowKey="id"
        size="small"
        columns={getColumns()}
        dataSource={props.stocks}
        pagination={{
          showSizeChanger: true,
          showTotal: (total) => `Total ${total} items`,
        }}
        rowSelection={rowSelection}
        rowClassName={(record) => getRowColor(record)}
        summary={(pageData) => {
          let totalQuantity = 0;
          let totalNetWeight = 0;
          //let totalGrossWeight = 0;

          pageData.forEach(
            ({ quantity, netWeight, grossWeight, grossValueSqm }) => {
              totalQuantity += quantity;
              totalNetWeight += netWeight;
              //totalGrossWeight += grossWeight;
            }
          );

          return (
            <>
              <Table.Summary.Row>
                <Table.Summary.Cell colSpan={10}>
                  <Text strong>Total</Text>
                </Table.Summary.Cell>
                <Table.Summary.Cell>
                  <Text strong style={{ paddingLeft: 12 }}>
                    {props.stocks && props.stocks.length}
                  </Text>
                </Table.Summary.Cell>
                <Table.Summary.Cell align="right">
                  <Text strong style={{ paddingLeft: 12 }}>
                    {totalQuantity}
                  </Text>
                </Table.Summary.Cell>
                <Table.Summary.Cell align="right">
                  <Text strong style={{ paddingLeft: 12 }}>
                    {!isNaN(totalNetWeight) &&
                      Number(totalNetWeight).toFixed(2)}
                  </Text>
                </Table.Summary.Cell>
                <Table.Summary.Cell />
                {/* <Table.Summary.Cell>
                  <Text strong style={{ paddingLeft: 12 }}>
                    {!isNaN(totalGrossWeight) &&
                      Number(totalGrossWeight).toFixed(2)}
                  </Text>
                </Table.Summary.Cell> */}
              </Table.Summary.Row>
            </>
          );
        }}
      />
      {selectedRowKeys.length > 0 && (
        <Descriptions title="" bordered style={{ marginTop: 15 }} size="small">
          <Descriptions.Item
            label="Material Type"
            span={3}
            contentStyle={{ fontWeight: "bold" }}
            labelStyle={{ fontWeight: "bold" }}
          >
            {selectedStocks.length > 0 && selectedStocks[0].stockType.code}
          </Descriptions.Item>
          <Descriptions.Item
            label="Material Description"
            span={3}
            contentStyle={{ fontWeight: "bold" }}
            labelStyle={{ fontWeight: "bold" }}
          >
            {selectedStocks.length > 0 && selectedStocks[0].stockType.name}
          </Descriptions.Item>
          <Descriptions.Item
            label="Lot Number"
            span={3}
            contentStyle={{ fontWeight: "bold" }}
            labelStyle={{ fontWeight: "bold" }}
          >
            {selectedStocks.length > 0 && selectedStocks[0].lotNumber.number}
          </Descriptions.Item>
          <Descriptions.Item
            label="Total Box"
            span={3}
            contentStyle={{ fontWeight: "bold" }}
            labelStyle={{ fontWeight: "bold" }}
          >
            {selectedStocks.length}
          </Descriptions.Item>
          <Descriptions.Item
            label="Total Cone"
            span={3}
            contentStyle={{ fontWeight: "bold" }}
            labelStyle={{ fontWeight: "bold" }}
          >
            {selectedStocks.length > 0 &&
              Number(
                selectedStocks
                  .map((item) => item.quantity)
                  .reduce((prev, next) => prev + next)
              ).toFixed(2)}
          </Descriptions.Item>
          <Descriptions.Item
            label="Net Weight(Kg)"
            span={3}
            contentStyle={{ fontWeight: "bold" }}
            labelStyle={{ fontWeight: "bold" }}
          >
            {selectedStocks.length > 0 &&
              Number(
                selectedStocks
                  .map((item) => item.netWeight)
                  .reduce((prev, next) => prev + next)
              ).toFixed(2)}
          </Descriptions.Item>
        </Descriptions>
      )}
    </div>
  );
};

export default StockSelection;
